import { Module } from "vuex";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { RootState } from "@/store/types";
import { PreviewState } from "@/services/preview/types";
import { actions } from "@/store/preview/actions";

export const state = {
    previewControlsStatus: true as boolean
} as PreviewState;

const namespaced: boolean = true;

export const preview: Module<PreviewState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
